import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import CeramicSpotlight from "@/components/CeramicSpotlight";
import Booking from "@/components/Booking";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { api } from "@/lib/api";

export default function HomePage() {
  const [services, setServices] = useState([]);
  const [initialService, setInitialService] = useState("");

  useEffect(() => {
    api
      .get("/services")
      .then((r) => setServices(r.data))
      .catch(() => setServices([]));
  }, []);

  const handleBook = (serviceId) => {
    setInitialService(serviceId);
    // ensure state re-triggers even if same id
    setTimeout(() => setInitialService(""), 500);
    const el = document.getElementById("booking");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services services={services} onBook={handleBook} />
        <CeramicSpotlight onBook={() => handleBook("ceramic-coating")} />
        <Gallery />
        <Booking services={services} initialService={initialService} />
        <GoogleReviews />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
